<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KKwKWK/tc-custom/9780814340608.jpg?1724209962779" alt="This image is the cover for the book Concrete Boxes, Raphael Patai Series in Jewish Folklore and Anthropology"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Concrete Boxes, Raphael Patai Series in Jewish Folklore and Anthropology
      </h1>
      <p class="bookDescription body article font2">
        
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pnina Motzafi-Haller, Virginia R. Dominguez
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2759ed84